import { apiGet, apiPostPut, apiDelete } from "./api_methods";
import { RECRUITER_JOBS_BASE, RECRUITER_JDS_BASE } from "./endpoints";

/**
 * List recruiter's job posts (GET /).
 * @param {Object} params - { skip, limit, clientId, searchFilter, isDeleted }
 * @returns {Promise<{ body, status }>}
 */
export async function listJobPosts(params = {}) {
  const q = {};
  if (params.skip != null) q.skip = params.skip;
  if (params.limit != null) q.limit = params.limit;
  if (params.clientId) q.clientId = params.clientId;
  if (params.searchFilter) q.searchFilter = params.searchFilter;
  if (params.isDeleted != null) q.isDeleted = params.isDeleted;
  const query = new URLSearchParams(q).toString();
  const path = query ? `${RECRUITER_JOBS_BASE}?${query}` : RECRUITER_JOBS_BASE;
  return apiGet(path);
}

/**
 * Get one job post by id (GET /:id).
 * @param {string} id - Job post ID
 * @param {Object} [queryParams] - Optional e.g. { clientId }
 * @returns {Promise<{ body, status }>}
 */
export async function getJobPost(id, queryParams = null) {
  const path =
    queryParams && Object.keys(queryParams).length > 0
      ? `${RECRUITER_JOBS_BASE}/${id}?${new URLSearchParams(queryParams).toString()}`
      : `${RECRUITER_JOBS_BASE}/${id}`;
  return apiGet(path);
}

/**
 * Create job post (POST /).
 * @param {Object} body - Job post payload (recruiterId set by server)
 * @returns {Promise<{ body, status }>}
 */
export async function createJobPost(body) {
  return apiPostPut(body, RECRUITER_JOBS_BASE, "POST");
}

/**
 * Update job post (PUT /:id).
 * @param {string} id - Job post ID
 * @param {Object} body - Partial job post fields to update
 * @returns {Promise<{ body, status }>}
 */
export async function updateJobPost(id, body) {
  return apiPostPut(body, `${RECRUITER_JOBS_BASE}/${id}`, "PUT");
}

/**
 * AI chat for job post (e.g. JD drafting) (POST /ai-chat).
 * @param {Object} body - { prompt, max_tokens?, stop?, model? }
 * @returns {Promise<{ body, status }>} body.data contains AI response (e.g. body.content)
 */
export async function postJobAiChat(body) {
  return apiPostPut(body, `${RECRUITER_JOBS_BASE}/ai-chat`, "POST");
}

/**
 * Soft-delete job post (DELETE /:id).
 * @param {string} id - Job post ID
 * @returns {Promise<{ body, status }>}
 */
export async function deleteJobPost(id) {
  return apiDelete(`${RECRUITER_JOBS_BASE}/${id}`);
}

/**
 * Get recruiter JDs (GET /v1/recruiter/jds).
 * @param {Object} params - { skip, limit, searchFilter, name, jd }
 * @returns {Promise<{ body, status }>}
 */
export async function getRecruiterJds(params = {}) {
  const q = {};
  if (params.skip != null) q.skip = params.skip;
  if (params.limit != null) q.limit = params.limit;
  if (params.searchFilter != null && params.searchFilter !== "")
    q.searchFilter = params.searchFilter;
  if (params.name != null && params.name !== "") q.name = params.name;
  if (params.jd != null && params.jd !== "") q.jd = params.jd;

  const query = new URLSearchParams(q).toString();
  const path = query ? `${RECRUITER_JDS_BASE}?${query}` : RECRUITER_JDS_BASE;
  return apiGet(path);
}
